<template lang="pug">
  div
    table.table
      thead.table__header
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          th.table__cell {{ 'base.delivery_value' | translate }}
          th.table__cell {{ 'base.price' | translate }}
          th.table__cell {{ 'base.type' | translate }}
          th.table__cell {{ 'base.delivery_company' | translate }}
          th.table__cell {{ 'base.date' | translate }}
      v-table-body(
        :cols="6"
        :loading="loading"
        :empty="!items.length")
        tr(
          v-for="item in items"
          :key="item.id"
          ).table__row
            td(:data-label="$t('base.name')").table__cell {{ item.ingredient ? item.ingredient.name : '-' }}
            td(:data-label="$t('base.delivery_value')").table__cell {{ item.amount | floor }} {{ 'base.kg' | translate }}
            td(:data-label="$t('base.price')").table__cell {{ item.price | floor }}
            td(:data-label="$t('base.type')").table__cell {{ item.delivery_type === 'input' ? 'base.delivery' : 'base.sale' | translate}}
            td(:data-label="$t('base.delivery_company')").table__cell {{ item.delivery_company ? item.delivery_company.name : '-' }}
            td(:data-label="$t('base.date')").table__cell {{ item.created_at | date }}

    //- TABLE PAGINATION
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import paginationMixin from '@/mixins/pagination.mixin'

import UiPagination from '@/components/ui/ui-pagination/UiPagination'

export default {
  name: 'DeliveriesTable',

  mixins: [paginationMixin],

  components: {
    UiPagination
  },

  mounted () {
    this.setupPagination(
      api.deliveries.list,
      {
        farm: this.$route.params.farm_id
      },
      `deliveries_${this.$route.params.farm_id}`
    )
  },

  computed: {
    ...mapGetters('deliveries', [
      'filters',
      'deliveries'
    ])
  },

  watch: {
    filters: {
      handler () {
        this.loadData(this.filters)
      },
      deep: true
    },
    deliveries: {
      handler () {
        this.loadData(this.filters)
      },
      deep: true
    }
  }
}
</script>
